module.exports = __webpack_public_path__ + "img/nextStepHover.6e02fc75.png";